var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('CNavbar'),_c('v-main',{staticClass:"main-layout__content"},[_c('div',{staticClass:"main-layout__content-wrapper"},[_c('router-view')],1)]),_c('CWaitor',{attrs:{"show":_vm.waitor.show,"message":_vm.waitor.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }